import { Button, DialogActions } from '@mui/material';
import {
  CloseDialogButton,
  Dialog,
  DialogContent,
  DialogContentWrapper,
  DialogTitle
} from 'apps/wrapper/src/components/shared/dialog/dialog.styles';
import { FC } from 'react';
import { InfoList } from '../dialogs.styles';

export interface LocationSwitchDialogProps {
  open: boolean;
  patientName: string;
  locationName: string | undefined;
  onClose: () => void;
  onUseCurrentLocation: () => void;
  onSwitchLocation: () => Promise<void>;
}

export const LocationSwitchDialog: FC<LocationSwitchDialogProps> = (props) => {
  const { open, patientName, locationName, onClose, onUseCurrentLocation, onSwitchLocation } = props;

  return (
    <Dialog
      open={open}
      maxWidth={false}
      sx={{
        '& .MuiDialog-paper': {
          width: '620px',
          maxWidth: '90%'
        }
      }}
    >
      <DialogContentWrapper>
        <CloseDialogButton onClick={onClose} />
        <DialogContent sx={{ width: 'auto', minHeight: 'auto', padding: '30px 10px 20px 10px' }}>
          <DialogTitle sx={{ cursor: 'default' }}>
            The patient you selected is attached to another location in the same network.
          </DialogTitle>
          <InfoList>
            <li>
              <label>Patient:</label>
              {patientName}
            </li>
            <li>
              <label>Location:</label> {locationName}
            </li>
          </InfoList>
          <DialogActions sx={{ padding: 0, marginTop: '35px' }}>
            <Button size="small" onClick={onClose} sx={{ marginRight: '10px' }} disableElevation>
              CANCEL
            </Button>
            <Button size="small" onClick={onUseCurrentLocation} sx={{ marginRight: '10px' }} disableElevation>
              OPEN IN THIS LOCATION
            </Button>
            <Button variant="contained" color="primary" size="small" onClick={onSwitchLocation} disableElevation>
              SWITCH PATIENT'S LOCATION AND OPEN
            </Button>
          </DialogActions>
        </DialogContent>
      </DialogContentWrapper>
    </Dialog>
  );
};
